import chatBubbleInner from '../../../assets/images/temp/chatBubbleInner_fixed.png'
import chatBubbleOuter from '../../../assets/images/temp/chatBubbleOuter.svg'

function Placeholder() {
    return (
        <div className='single-chat single-chat-placeholder mobile-display-none'>
            <div className='messages__nomessages'>
                <div className='messages__nomessages__bubble'>
                    <img
                        className='messages__nomessages--outer'
                        src={chatBubbleOuter}
                        alt='Chat bubble outer icon'
                    />

                    <img
                        className='messages__nomessages--inner'
                        src={chatBubbleInner}
                        alt='Chat bubble inner'
                    />
                </div>

                {/* <h2 className='messages__nomessages__title'>No Messages</h2> */}

                <p className='messages__nomessages__text'>
                    Select a Conversation
                </p>
            </div>
        </div>
    )
}

export default Placeholder